"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-skeleton", {
    attrs: {
      loading: _vm.loading,
      paragraph: {
        rows: 4
      },
      active: ""
    }
  }, [_vm.templateList.length === 0 ? _c("a-empty", {
    staticClass: "m-m-t-64",
    attrs: {
      description: "暂无公共模板，请联系管理员添加"
    }
  }) : _c("a-layout", {
    staticClass: "template-layout"
  }, [_c("a-layout-sider", {
    staticClass: "template-layout_sider",
    attrs: {
      width: 180
    }
  }, [_c("a-menu", {
    attrs: {
      mode: "vertical",
      theme: "light"
    },
    model: {
      value: _vm.templateId,
      callback: function ($$v) {
        _vm.templateId = $$v;
      },
      expression: "templateId"
    }
  }, _vm._l(_vm.templateList, function (item) {
    return _c("a-menu-item", {
      key: item.id
    }, [_vm._v(_vm._s(item.name))]);
  }), 1)], 1), _c("a-layout-content", {
    staticClass: "template-layout_content"
  }, [_c("BasisTableLayout", {
    attrs: {
      selectable: true,
      "empty-desc": "暂无数据",
      pagination: false,
      sort: false,
      scroll: {
        x: false,
        y: "calc(70vh - 140px)"
      },
      "default-expanded-row-keys": _vm.defaultExpandedRowKeys,
      columns: _vm.columns,
      "data-source": _vm.dataSource
    },
    on: {
      rowSelectionChange: _vm.rowSelectionChange
    },
    model: {
      value: _vm.selectedIds,
      callback: function ($$v) {
        _vm.selectedIds = $$v;
      },
      expression: "selectedIds"
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;